
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/advanced-settings",
      function () {
        return require("private-next-pages/advanced-settings/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/advanced-settings"])
      });
    }
  